import script from "./EnableWhatsAppWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnableWhatsAppWidget.vue?vue&type=script&setup=true&lang=ts"

import "./EnableWhatsAppWidget.vue?vue&type=style&index=0&id=27466a54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27466a54"]])

export default __exports__